var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37",
    x1: 55.453,
    y1: 121.646,
    x2: 82.053,
    y2: 121.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37",
    x1: 50.825,
    y1: 104.576,
    x2: 86.836,
    y2: 104.576,
    xlinkHref: "#SVGID_0_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37",
    x1: 42.34,
    y1: 97.508,
    x2: 95.889,
    y2: 97.508,
    xlinkHref: "#SVGID_0_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37",
    x1: 51.227,
    y1: 91.674,
    x2: 86.707,
    y2: 91.674,
    xlinkHref: "#SVGID_0_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37",
    x1: 39.787,
    y1: 124.48,
    x2: 97.869,
    y2: 124.48,
    xlinkHref: "#SVGID_0_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M126.201 126.302s2.712.957 7.978 0c5.265-.957 8.297-3.351 8.297-3.351s3.351 3.829 8.137 3.829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M80.803 118.091c-2.247 4.339-6.777 7.304-12 7.304-5.301 0-9.888-3.054-12.099-7.498",
    stroke: "url(#SVGID_0_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M85.495 95.575c.06.577.091 1.163.091 1.756 0 9.254-7.502 16.756-16.756 16.756s-16.756-7.502-16.756-16.756c0-.771.091-1.524.192-2.267",
    stroke: "url(#SVGID_1_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M51.677 119.073c-5.054-1.516-8.087-5.307-8.087-5.307s1.769-1.011 3.285-4.296c1.516-3.285.566-12.203.566-12.203 0-11.847 9.604-21.45 21.45-21.45s21.45 9.604 21.45 21.45c0 0-.505 9.17 1.769 13.088a13.092 13.092 0 002.527 3.412s-2.906 3.159-7.961 5.433",
    stroke: "url(#SVGID_2_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M52.477 95.065s3.959.295 9.982-1.264c6.065-1.516 12.046-5.981 12.046-5.981s3.959 6.697 10.951 7.708",
    stroke: "url(#SVGID_3_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M41.037 134.867c3.54-12.009 14.648-20.774 27.804-20.774s24.209 8.722 27.777 20.685",
    stroke: "url(#SVGID_4_cb24f7cede3b7123f613ad5038e5396051a9f0fd56cee060db95ff2c2c1ade37)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M34.281 61.759h69.235v73.412H34.281zM147.373 146.202a9.972 9.972 0 01-8.861 5.393 9.972 9.972 0 01-8.934-5.537"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M118.179 158.042c2.785-8.585 10.848-14.792 20.361-14.792 9.455 0 17.478 6.131 20.309 14.634"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M113.02 104h51.125v54.249H113.02zM128.538 75.523c-6.145-.419-7.367-1.885-7.367-1.885v-8.547c.812-8.545 8.008-15.229 16.766-15.229s15.885 6.62 16.754 15.106v9.404s-1.362.838-7.088 1.257"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 138.403,
    cy: 130.215,
    rx: 12.978,
    ry: 12.76
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M146.92 82.325a9.972 9.972 0 01-8.861 5.393 9.972 9.972 0 01-8.934-5.537"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M117.729 94.154c2.788-8.58 10.849-14.781 20.358-14.781s17.542 6.18 20.343 14.737"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M112.567 40.177h51.125v54.194h-51.125z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M149.362 60.92c.44 0 1.348 3.648 1.348 5.696 0 7.005-5.679 12.684-12.684 12.684s-12.684-5.679-12.684-12.684c0-2.029.476-3.947 1.324-5.648 0 0 8.115 3.471 22.697-.048z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.bdd1457e5ea893ed4870d2d69702cec6.svg";
export { ForwardRef as ReactComponent };